import { useMemo, useState } from 'react';
import { ComboboxOption } from '../types';

/**
 * Hook for managing dynamic options in a multi-select combobox
 */
export const useMultiOptions = <T extends string | number = string, O extends ComboboxOption<T> = ComboboxOption<T>>(items: O[], initialValue: T[] = []) => {
  const [options, setOptions] = useState<O[]>(items);
  const [value, setValue] = useState<T[]>(initialValue);
  const valueItems: O[] = useMemo(() => value.map(val => {
    return options.find(opt => opt.value === val);
  }).filter(Boolean) as O[], [value]);

  /**
   * Creates a new option and adds it to the options array
   */
  const createOption = (item: O): O => {
    setOptions([...options, item]);
    setValue([...value, item.value]);
    return item;
  };

  const setValueItems = (items: O[]) => {
    setValue(items.map(opt => opt.value));
  };

  return {
    value,
    setValue,
    valueItems,
    setValueItems,
    options,
    setOptions,
    createOption,
  };
};